export default __webpack_public_path__ + "static/media/clinocta.8426fa7c.jpg";